import { driver } from 'driver.js';

import 'driver.js/dist/driver.css';

export { driver };
export type { Config, DriveStep, PopoverDOM, State } from 'driver.js';
